var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useRef } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';
import { useTranslation } from 'react-i18next';
import displayToast from '../../Util/Toast';
const ProposalShareModal = ({ hideProposalShareModal, shareLink }) => {
    const { t } = useTranslation();
    const shareLinkRef = useRef(null);
    const ref = useOnclickOutside(() => {
        hideProposalShareModal();
    });
    const copyShareLink = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!shareLinkRef.current) {
            return;
        }
        shareLinkRef.current.select();
        if (navigator.clipboard) {
            try {
                yield navigator.clipboard.writeText(shareLink);
                displayToast(`<span class="material-icons">info</span><span>${t('proposalDetail.linkCopied')}</span>`, 'info', true);
            }
            catch (error) {
                displayToast((error === null || error === void 0 ? void 0 : error.message) || ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.message) || 'Error', 'error');
            }
        }
    });
    const shareProposalUrl = (type) => {
        switch (type) {
            case 'whatsapp':
                const encodedMessage = encodeURIComponent(shareLink);
                const whatsappURL = `whatsapp://send?text=${encodedMessage}`;
                window.open(whatsappURL);
                break;
            case 'linkedin':
                window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${shareLink}`, '_blank');
                break;
            case 'facebook':
                window.open(`https://www.facebook.com/sharer.php?u=${shareLink}`, '_blank');
                break;
            case 'twitter':
                window.open(`https://twitter.com/intent/tweet?url=${shareLink}`, '_blank');
                break;
            case 'clipboard':
                copyShareLink();
                break;
        }
    };
    return (React.createElement("div", { tabIndex: -1, className: "overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-full md:h-screen justify-center items-center flex bg-gray-50 bg-opacity-75", role: "dialog" },
        React.createElement("button", { onClick: hideProposalShareModal, type: "button", className: "absolute rounded-full top-6 right-6 w-12 h-12 inline-flex items-center justify-center bg-gray-200 hover:bg-gray-100 focus:outline-none text-gray-800" },
            React.createElement("span", { className: "material-icons" }, "close")),
        React.createElement("div", { ref: ref, className: "flex flex-col justify-center p-10 m-auto mx-3 mt-24 md:max-w-xl md:w-full bg-white rounded-lg gap-6 shadow-lg" },
            React.createElement("div", { className: "flex flex-col gap-2 text-center max-w-70 mx-auto" },
                React.createElement("h3", { className: "text-3xl font-semibold text-gray-800" }, t('proposalDetail.shareModal.title')),
                React.createElement("p", { className: "text-gray-800 text-lg leading-6" }, t('proposalDetail.shareModal.description'))),
            React.createElement("div", { className: "flex flex-col w-full gap-2" },
                React.createElement("input", { ref: shareLinkRef, type: "text", value: shareLink, readOnly: true, className: "bg-gray-100 rounded-lg px-4 py-2.5 focus:outline-none text-gray-700 text-xl leading-8" }),
                React.createElement("button", { type: "button", onClick: () => {
                        return shareProposalUrl('clipboard');
                    }, className: "rounded-md w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold p-3 text-lg focus:outline-none" }, t('proposalDetail.shareModal.copyUrl'))),
            React.createElement("div", { className: "flex flex-wrap justify-center items-center gap-12 mx-auto" },
                React.createElement("button", { type: "button", onClick: () => shareProposalUrl('whatsapp'), className: "flex flex-col items-center gap-2" },
                    React.createElement("img", { src: "/images/svg/whatsapp.svg", alt: "Whatsapp", className: "w-12 h-12" }),
                    React.createElement("span", { className: "text-gray-800 text-base leading-6 text-center" }, "Whatsapp")),
                React.createElement("button", { type: "button", onClick: () => shareProposalUrl('linkedin'), className: "flex flex-col items-center gap-2" },
                    React.createElement("img", { src: "/images/svg/linkedin.svg", alt: "LinkedIn", className: "w-12 h-12" }),
                    React.createElement("span", { className: "text-gray-800 text-base leading-6 text-center" }, "LinkedIn")),
                React.createElement("button", { type: "button", onClick: () => shareProposalUrl('facebook'), className: "flex flex-col items-center gap-2" },
                    React.createElement("img", { src: "/images/svg/facebook.svg", alt: "Facebook", className: "w-12 h-12" }),
                    React.createElement("span", { className: "text-gray-800 text-base leading-6 text-center" }, "Facebook")),
                React.createElement("button", { type: "button", onClick: () => shareProposalUrl('twitter'), className: "flex flex-col items-center gap-2" },
                    React.createElement("img", { src: "/images/svg/twitter.svg", alt: "X", className: "w-12 h-12" }),
                    React.createElement("span", { className: "text-gray-800 text-base leading-6 text-center" }, "X/Twitter"))))));
};
export default ProposalShareModal;
